import {mount} from 'svelte';

import {onPageReady} from '@js/modules/utils';

const FavoriteButton = () => import('@js/components/ride/FavoriteButton.svelte');

const initializeFavoriteMounts = () => {
    onPageReady(() => {
        const mounts = document.querySelectorAll('.favorite-mount[data-favorite-ride-id]');
        if (!mounts.length) return;

        FavoriteButton().then(({default: FavoriteButtonComponent}) => {
            mounts.forEach((element) => {
                mount(FavoriteButtonComponent, {
                    target: element,
                    props: {
                        rideId: element.getAttribute('data-favorite-ride-id'),
                        variant: 'overlay'
                    }
                });
            });
        });
    });
};

export default initializeFavoriteMounts;
